// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import VueAxios from "vue-axios";
import VueAuthenticate from "vue-authenticate";
import axios from "axios";

import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { ApolloLink } from 'apollo-link'
import { InMemoryCache } from 'apollo-cache-inmemory'
// New Imports
import { split } from 'apollo-link'
import { WebSocketLink } from 'apollo-link-ws'
import { getMainDefinition } from 'apollo-utilities'
import VueApollo from 'vue-apollo';
import store from './store';
import router from './Routes';
import App from './App';
import VueIziToast from 'vue-izitoast';
import VueMeta from 'vue-meta'
import LoadScript from 'vue-plugin-load-script';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import SimpleAnalytics from "simple-analytics-vue";
import Vue2Filters from 'vue2-filters'
Vue.use(Vue2Filters);
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts);
import Donut from 'vue-css-donut-chart';
import 'vue-css-donut-chart/dist/vcdonut.css';
import VueWorker from 'vue-worker'
Vue.use(VueWorker);

Vue.use(SimpleAnalytics, { skip: process.env.VUE_APP_API_ROOT === "http://127.0.0.1:8000/api/v1/" });
Vue.use(Donut);

Vue.component('apexchart', VueApexCharts)

if (process.env.VUE_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [new Integrations.Vue({Vue, attachProps: true, logErrors: true})],
  });
}

import 'izitoast/dist/css/iziToast.css';
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VuePluralize from 'vue-pluralize';
Vue.use(LoadScript);
Vue.use(VueMeta);
let tokenName = 'token';
if (!['admin', 'login', 'register'].includes(window.location.pathname.split('/')[1])){
  tokenName = 'readonly-token';
  localStorage.setItem(`vue-authenticate.${tokenName}`, window.location.pathname.split('/')[1]);
}

Vue.use(VuePluralize);
Vue.use(VueIziToast);
const httpLink = new HttpLink({
  // You should use an absolute URL here
  uri: process.env.VUE_APP_HASURA_HTTPLINK,
});

// required to work around (old?) bug, https://github.com/hasura/graphql-engine/issues/2961
const getHeaders = () => {
  const headers = {};
  const token = window.localStorage.getItem(`vue-authenticate.${tokenName}`);
  if (token) {
    headers.authorization = `Token ${token}`;
  }
  return headers;
};
// Create the subscription websocket link
const wsLink = new WebSocketLink({
  uri: process.env.VUE_APP_HASURA_WSLINK,
  options: {
    reconnect: true,
    connectionParams: () => {
      return { headers: getHeaders() };
    },
  },
});
// using the ability to split links, you can send data to each link
// depending on what kind of operation is being sent
const link = split(
  // split based on operation type
  ({ query }) => {
    const definition = getMainDefinition(query)
    return definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
  },
  wsLink,
  httpLink
);

const authMiddleware = new ApolloLink((operation, forward) => {
  // add the authorization to the headers
  const token = localStorage.getItem(`vue-authenticate.${tokenName}`);
  operation.setContext({
    headers: {
      authorization: token ? `Token ${token}` : null
    }
  });

  return forward(operation)
});

// Create the apollo client
const apolloClient = new ApolloClient({
  link: authMiddleware.concat(link),
  cache: new InMemoryCache(),
  connectToDevTools: true,
});

Vue.use(require('vue-moment'));
Vue.use(VueApollo);
Vue.use(VueAxios, axios);
Vue.use(VueAuthenticate, {
  baseUrl: process.env.VUE_APP_API_ROOT, //"http://localhost:8000/api/v1", // api
  tokenPrefix: "",
  tokenPath: "token",
  tokenName: tokenName,
  tokenHeader: 'Authorization',
  tokenType: "Token",
  providers: {
    github: {
      scope: ["user:email"],
      optionalUrlParams: ["scope"],
      clientId: process.env.VUE_APP_GITHUB_CLIENT_ID,
      redirectUri: `${process.env.VUE_APP_DOMAIN_ROOT}auth/callback` // "http://localhost:8080/auth/callback" // Your client app URL
    },
    google: {
      clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
      redirectUri: `${process.env.VUE_APP_DOMAIN_ROOT}auth/callback` // "http://localhost:8080/auth/callback" // Your client app URL
    }
  },
});


const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
});

Vue.use(BootstrapVue);
axios.defaults.baseURL = process.env.VUE_APP_API_ROOT;
// register globally

Vue.config.productionTip = false;



/* eslint-disable no-new */
let v = new Vue({
  store,
  router,
  apolloProvider,
  render: h => h(App),
});

if (v.$auth.getToken()) {  // this is required so that the axios interceptors work for the Token o_O
  v.$store.dispatch("reloadAll").then(() => {
    v.$mount("#app");
  });
}
else{
  v.$store.dispatch("reloadAll").then(() => {
    v.$mount("#app");
  });
}
